// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","badgesArea":"_3FvU6priMovL1yqaJ0GrSv","inline":"_3M5TwziOCDbcNVMvd2WEJj","badgesList":"_2jHcphthe3PqIsXjGfLvF9"};